import { Ago } from "azure-devops-ui/Ago";
import { Button } from "azure-devops-ui/Button";
import * as React from "react";
import "./Timeline.scss";
import { css } from "azure-devops-ui/Util";
import { Icon } from "azure-devops-ui/Icon";

export const Timeline: React.FC = props => (
  <div className="timeline">
    <div className="timeline-line" />
    {props.children}
  </div>
);

///

export const TimelineSmallIcon: React.FC = props => {
  return (
    <div className="timeline-icon-small flex-row flex-center justify-center">
      {props.children}
    </div>
  );
};

export const TimelineLargeIcon: React.FC = props => {
  return (
    <div className="timeline-icon-large flex-row flex-center justify-center">
      {props.children}
    </div>
  );
};

///

export const TimelineTimestamp: React.FC<{ date: Date }> = ({ date }) => {
  return <Ago className="timeline-entry-timestamp" date={date} format={0} />;
};

///

export interface ITimelineEntryProps {
  renderIcon: () => JSX.Element;
  date?: Date;

  className?: string;
}

export const TimelineEntry: React.FC<ITimelineEntryProps> = props => {
  return (
    <div
      className={css("timeline-entry flex-row flex-center", props.className)}
    >
      <div className="timeline-entry-icon flex-row flex-center justify-center">
        {props.renderIcon()}
      </div>
      <div
        className={css(
          "timeline-entry-content flex-row flex-center",
          !props.date && "flex-grow"
        )}
      >
        {props.children}
      </div>
      {props.date && <TimelineTimestamp date={props.date} />}
    </div>
  );
};

export const TimelineShowMore: React.FC = () => {
  return (
    <div className="timeline-show-more flex-row flex-center justify-center">
      <div className="timeline-show-more-line flex-row flex-center justify-center">
        <Button className="timeline-show-more-button flex-row flex-center justify-center">
          <div>Show 32 more</div>
          <Icon iconName="ChevronUnfold10" />
        </Button>
      </div>
    </div>
  );
};
